import { memo } from 'react'

import CreateFinalAfterInactivity, {
  InactivityType
} from './containers/CreateFinalAfterInactivity'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { getAge } from 'utils/date'
import {
  determineTimeout,
  TIMEOUT_FIVE_MINUTES
} from 'InactivityContainer.helpers'

type InactivityProps = {
  handleSubmit: () => void
  isSmava?: boolean
}

const InactivityContainer = ({ handleSubmit, isSmava }: InactivityProps) => {
  const {
    rootStore: {
      traversal: {
        data: {
          debtors: {
            primary: {
              personal: { birthday }
            }
          }
        }
      }
    }
  } = useRootStore()

  const debtorsAge = getAge(birthday)

  let timeout = determineTimeout(debtorsAge, isSmava || false)

  if (!timeout) {
    return null
  }

  return (
    <>
      <CreateFinalAfterInactivity
        timeout={TIMEOUT_FIVE_MINUTES}
        inactivityType={InactivityType.PAYOUT_ACCOUNT_INACTIVITY}
        onNext={handleSubmit}
      />
      <CreateFinalAfterInactivity
        timeout={timeout}
        inactivityType={InactivityType.DAC_INACTIVITY}
        onNext={handleSubmit}
      />
    </>
  )
}

export default memo(InactivityContainer)
